import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TreeviewConfig, TreeviewItem } from 'ngx-treeview';

@Component({
  selector: 'app-multiple-dropdown',
  templateUrl: './multiple-dropdown.component.html',
  styleUrls: ['./multiple-dropdown.component.scss'],
})
export class MultipleDropdownComponent implements OnInit {
  @Input() config: TreeviewConfig = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 250,
  });
  @Input() items: Array<TreeviewItem> = [];
  @Input() displayText: string;
  @Input() allowClear: boolean = true;
  @Output() itemChange = new EventEmitter<Array<TreeviewItem>>();

  selectedItems: Array<TreeviewItem> = [];
  status: { isopen: boolean } = { isopen: false };

  constructor() {}

  ngOnInit() {
    this.selectedItems = this.items.filter((x) => x.checked);
    this.sortByText();
  }

  multiSelect(item: TreeviewItem) {
    item.checked = !item.checked;
    this.updateCheckedItems(item);
  }

  clearTreeview() {
    this.selectedItems = [];
    this.items.forEach((i) => i.setCheckedRecursive(false));
    this.itemChange.emit(this.selectedItems);
  }

  private updateCheckedItems(item: TreeviewItem) {
    if (item.checked) {
      this.addToSelectedItem(item);
    } else {
      this.deleteItemsFromSelected(this.selectedItems, item);
    }
    this.itemChange.emit(this.selectedItems);
  }

  private addToSelectedItem(item: TreeviewItem) {
    this.selectedItems.push(item);
  }

  private deleteItemsFromSelected(
    items: Array<TreeviewItem>,
    item: TreeviewItem
  ): Array<TreeviewItem> {
    const index = items.findIndex((x) => item.value === x.value);
    items.splice(index, 1);
    return items;
  }

  private sortByText() {
    this.items.sort((a, b) => a.text.localeCompare(b.text));
  }
}
